import * as React from 'react';
import { Widget } from '@kmx/instant-offer-expatriate';
import Box from '@mui/material/Box';
import InstantOffersContainer from './InstantOffersContainer';
import CoverSection from '../CoverSection/CoverSection';
import { loadInstantOffersComponentAssets } from './utils/loadInstantOffersComponentAssets';
import useAppState from '../../common/state/appState';
import { getEnvConfig } from '../../utilities/environmentConfig';

interface ILegacySectionState {
    styleLoaded: boolean;
    scriptLoaded: boolean;
}

class LegacyInstantOffersSection extends React.Component<{}, ILegacySectionState> {
    constructor(props: {}) {
        super(props);
        this.state = { styleLoaded: false, scriptLoaded: false };
    }

    public componentDidMount() {
        loadInstantOffersComponentAssets(
            () => this.setState({ scriptLoaded: true }),
            () => this.setState({ styleLoaded: true }),
        );
    }

    public render(): React.ReactNode {
        return this.state.scriptLoaded && this.state.styleLoaded && <InstantOffersContainer />;
    }
}

const InstantOffersSection = () => {
    const serveUFTContentEnabled = useAppState((state) => state.serveUFTContent);

    if (serveUFTContentEnabled) {
        const { baseUrl } = getEnvConfig();
        return (
            <CoverSection noPaddingMobile>
                <Box sx={{ width: { sm: '342px', md: '480px' } }}>
                    <Widget baseUrl={baseUrl} originPage="Home" />
                </Box>
            </CoverSection>
        );
    }

    return <LegacyInstantOffersSection />;
};

export default InstantOffersSection;
